import React from 'react';
import PropTypes from 'prop-types'

const Input = ({ type, name, id, classes, value, placeholder, pattern, maxlength, style, onChange, error }) => {
  const inlineStyles = style
  return (
      <input
        type={type}
        name={name}
        id={id || name}
        className={ error ? `error ${classes}` : classes}
        value={value}
        placeholder={placeholder}
        pattern={pattern}
        maxLength={maxlength}
        onChange={onChange}
        style={inlineStyles}
      />
  );
}

Input.propTypes = {
  onChange: PropTypes.func.isRequired
}

Input.defaultProps = {
  type: 'text',
  placeholder: 'Deine E-Mail-Adresse'
}

export default Input
